// extracted by mini-css-extract-plugin
export default {"root":"Title_root__Ud6cB"};